import React, { Component } from "react";
import { bindActionCreators } from "redux";
import withRedux from "next-redux-wrapper";
import withReduxSaga from "next-redux-saga";
import Head from "next/head";
import PropTypes from "prop-types";
import Store from "store";
import { fetchCategories } from "store/posts/actions";
import NProgress from "components/NProgress";
import Header from '/container/DefaultLayout/header';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Axios from "/plugins/axios";
import Footer from "/container/DefaultLayout/footer.js"
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';

const styles = theme => ({
    layout: {
        [theme.breakpoints.up('sm')]: {
        width: 900,
        marginLeft: 'auto',
        marginRight: 'auto',
        },
        [theme.breakpoints.only('sm')]: {
        width: 650,
        marginLeft: 'auto',
        marginRight: 'auto',
        },
    },
    textField: {
        padding: '20px 0px',
        // margin: '25px 0px 50px',
        width: '100%',
      },
     
});



class SearchInput extends Component {

  render() {
    const { categories, classes } = this.props;

    return (
      <div className={classes.layout}>
            <Grid container>
                <Grid item xs={12} style={{marginBottom: 10}}>
                    <TextField
                    id="standard-search"
                    placeholder="Type your keywords"
                    type="search"
                    className={classes.textField}
                    margin="normal"
                    InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                                <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                   
                </Grid>
            </Grid>
      </div>
    );
  }
}

SearchInput.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(SearchInput);

